import { Col, Row, Select, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useQuestions, useSurveys } from '../../../api/Surveys';

const { Text } = Typography;

function CodeFrameSelect({ value = null, onChange }) {
  const { data: surveys, isLoading: surveysLoading } = useSurveys({
    select: (data) => data.data.filter((s) => !s.is_demo),
  });

  const [selectedSurveyId, setSelectedSurveyId] = React.useState(null);

  const { data: questions, isFetching: questionsFetching } = useQuestions(
    { surveyId: selectedSurveyId },
    {
      enabled: !!selectedSurveyId,
      select: (data) => data.data.filter((q) => q.has_themes && q.code_frame_id),
    },
  );

  const onSurveyChange = (newSurveyId) => {
    setSelectedSurveyId(newSurveyId);
    onChange(null);
  };

  const onQuestionChange = (newCodeFrameId) => {
    onChange(newCodeFrameId);
  };

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Text strong>Select the survey and question to reapply code frame from</Text>
      </Col>
      <Col span={12}>
        <Select
          value={selectedSurveyId}
          placeholder="Select survey"
          onChange={onSurveyChange}
          loading={surveysLoading}
          options={surveys?.map((s) => ({
            value: s.id,
            label: s.name,
          }))}
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
          style={{ width: '100%' }}
        />
      </Col>
      <Col span={12}>
        <Select
          value={value}
          placeholder="Select question"
          onChange={onQuestionChange}
          loading={questionsFetching}
          disabled={!selectedSurveyId || questionsFetching}
          options={questions?.map((q) => ({
            value: q.code_frame_id,
            label: q.text,
          }))}
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
          style={{ width: '100%' }}
        />
      </Col>
    </Row>
  );
}

CodeFrameSelect.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default CodeFrameSelect;
